import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import VideoCarousel from "./components/VideoCarousel";
import CustomerSuccessSection from "./components/CustomerSuccessSection";

function LeadMagnetPage() {
  const [searchParams] = useSearchParams();
  const [name, setName] = useState("");

  useEffect(() => {
    const nameParam = searchParams.get("name");
    if (nameParam) {
      setName(nameParam);
    }
  }, [searchParams]);

  const scrollToContent = () => {
    window.scrollTo({
      top: window.innerHeight,
      behavior: "smooth",
    });
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white">
      <div className="max-w-5xl w-full text-center px-6 pt-48 flex flex-col justify-center items-center">
        <img src="/logo.svg" alt="UGZ Ai" className="h-10 mx-auto mb-8" />

        <p className="text-2xl font-medium text-gray-800 mb-2">
          Hey{name ? ` ${name}` : ","}
        </p>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-slate-800 via-slate-700 to-slate-800 mb-8 tracking-tight max-w-3xl animate-fade-in text-center">
          Get a Walkthrough <span className="font-normal">+</span> 10 Free AI
          UGC Videos
        </h1>

        <a
          href="https://calendly.com/mikay-ugz/tiktok-shop-ai-ugc"
          target="_blank"
          className="px-6 py-3 bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 text-white font-semibold rounded-xl flex items-center gap-2 mx-auto transition-all duration-200 shadow-md hover:cursor-pointer mb-8 "
        >
          Schedule a 5 Minute Call <span className="text-lg">›</span>
        </a>

        <button
          onClick={scrollToContent}
          className="animate-bounce mx-auto text-gray-500 hover:text-gray-700 transition-colors focus:outline-none hover:cursor-pointer"
          aria-label="Scroll down"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-chevron-down"
          >
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </button>
      </div>
      <VideoCarousel />
      <CustomerSuccessSection />
    </div>
  );
}

export default LeadMagnetPage;
